
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
::slotted(a),:host,a{color:var(
    --outline-link-color-default,var(--outline--link-default-color-default)
  );font-family:var(--ff-body);-webkit-text-decoration:var(
    --outline-link-color-default-decoration,var(--outline--link-default-color-default-decoration)
  );text-decoration:var(
    --outline-link-color-default-decoration,var(--outline--link-default-color-default-decoration)
  );transition-duration:var(
    --outline-link-transition-duration,var(--outline--link-default-transition-duration)
  );transition-property:var(
    --outline-link-transition-property,var(--outline--link-default-transition-property)
  );transition-timing-function:var(
    --outline-link-transition-timing-function,var(--outline--link-default-transition-timing-function)
  )}::slotted(a:hover),:host(:hover),a:hover{color:var(
    --outline-link-color-hover,var(--outline--link-default-color-hover)
  );-webkit-text-decoration:var(
    --outline-link-color-hover-decoration,var(--outline--link-default-color-hover-decoration)
  );text-decoration:var(
    --outline-link-color-hover-decoration,var(--outline--link-default-color-hover-decoration)
  )}::slotted(a:focus),:host(:focus),a:focus{color:var(
    --outline-link-color-focus,var(--outline--link-default-color-focus)
  );outline:none;-webkit-text-decoration:var(
    --outline-link-color-focus-decoration,var(--outline--link-default-color-focus-decoration)
  );text-decoration:var(
    --outline-link-color-focus-decoration,var(--outline--link-default-color-focus-decoration)
  )}`;